<style lang="less">
@import "../../../styles/common.less";
</style>
<template>
  <div class="evidenceInfo">
    <div class="evidenceInfo-top" style="min-height:727px">
      <div class="evidenceInfo-top-title">取证详情</div>
      <ul class="evidenceInfo-ul">
        <li>
          <span style="width:70px">取证网址：</span>
          <span class="spanRight">{{list.url?list.url:'-'}}</span>
        </li>
         <li>
          <span style="width:70px">服务器IP：</span>
          <span class="spanRight">{{list.dnsServerIp?list.dnsServerIp:'-'}}</span>
        </li>
         <li style="margin-bottom:20px">
          <span style="width:70px">取证时间：</span>
          <span class="spanRight">{{list.createDate?list.createDate:'-'}}</span>
        </li>
        <li class="img-box-li" :style="{ height: heightLi}" v-if="list.screenshotUrl">
          <img :src="list.screenshotUrl+'?x-image-process=image/resize,m_fixed,w_1262'" class="img-style" />
          <div class="img-box-mask">
            <button class="img-box-more" @click="showMoreImg" :style="{cursor: 'pointer'}">{{btnConten}}</button>
          </div>
        </li>
      </ul>
    </div>
    <div class="evidenceInfo-top" style="min-height:357px" v-if="status=='取证完成'">
      <div class="evidenceInfo-top-title">取证证书</div>
      <div class="evidence-bottom">  
        <div style="width:166px;margin-right:20px"><img src="@/assets/evidence-img.png" /></div>
        <div class="evidence-bottom-right" >
          <p class="p-one">{{list.name?list.name+'-':''}}取证证书</p>
          <ul class="evidence-bottom-ul">
            <li>
              <span style="width:70px">证书状态：</span>
              <span>已认证</span>
            </li>
             <li>
              <span style="width:70px">证书编号：</span>
              <span>{{list.evidenceOrderExtends.evidenceArchiveCertNumber}}</span>
            </li>
             <li>
              <span style="width:70px">核验单位：</span>
              <span>中国科学院国家授时中心、北京天威诚信电子商务服务有限公司、版权区块链联盟</span>
            </li>
             <li>
              <span style="width:70px">认证日期：</span>
              <span>{{list.createDate?list.createDate.split(' ')[0]:''}}</span>
            </li>
          </ul>
          <div>
            <button class="btn-76" @click="openVerify">证书核验</button>            
            <a :href="list.evidenceOrderExtends.certSignaturePdfUrl" target="_blank" style="display:inline-block;margin:0px 15px;" class="btn-76" >下载证书</a>            
            <a :href="list.packageUrl" class="btn-76" style="display:inline-block;width:126px;">下载取证数据包</a>
          </div>
        </div>
      </div>
    </div>
    <!-- 核验码 -->
    <verifycode @fatherModal="fatherModal" v-show="showModal" ref="childModal" :flag='flag' :orderSeqNo='orderSeqNo'></verifycode>
  </div>
</template>

<script>
import verifycode from '../verification/verifyCode'; 
export default {
  metaInfo: {
      title: '取证详情|时尚知识产权保护平台',
      meta: [{                 // set meta
          name: 'keyWords',
          content: ''
      },{
          name: 'Description',
          content: ''
      }]
  },
  name: "evidenceInfo",
  components:{
    verifycode
  },
  data(){
    return{
      list:"",
      status:"",
      showModal:!1,
      flag:'f1',
      orderSeqNo:"",
      heightLi:'512px',
      btnConten:'查看完整图片',
      showAllImg:true
    }
  },
  methods: {
     getEvidenceWebpage(){
      this.getRequest('/evidenceWebpage/get/'+this.$route.query.id).then(res=>{
        if(res.code==200){
         this.list=res.result;
         this.status=res.result.evidenceOrder.status;
         this.orderSeqNo=res.result.orderSeqNo
        }
      })
    },
    fatherModal() {
        let _this = this;
        _this.showModal = !1;
    },
    openVerify(){
      // let _this = this;
      // _this.showModal = !0;
      // let routeUrl = this.$router.resolve({
      //   path: "/index/creation_verification",
      //   name:'creationVerification',
      //   params: {type:this.flag,id:this.orderSeqNo}
      // });
      // window.open(routeUrl.href, '_blank');
       window.open(this.API_ROOT_UPLOAD+"verification/" + this.flag+'/'+this.orderSeqNo, '_blank');
    },
    showMoreImg(){
      this.showAllImg=!this.showAllImg;
      if(this.showAllImg){
        this.btnConten="查看完整图片";
        this.heightLi='512px';
      }else{
        this.btnConten="收起图片";
        this.heightLi='auto';
      }
      
    }
  },
  created() {
    this.getEvidenceWebpage()
  },
};
</script>
<style scoped lang="less">
.img-box-li{
  position:relative;
  overflow: hidden;
  display: block!important;
  .img-style{
    max-width: 100%;
    height: auto;
  }
  .img-box-mask{
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 100px;
    background-image: linear-gradient(0deg,#fff,hsla(0,0%,100%,0));
    text-align: center;
    .img-box-more{
      outline: none;
      width: 140px;
      height: 30px;
      line-height: 30px;
      font-size: 16px;
      color: #666;
      text-align: center;
      background: gainsboro;
      border-radius: 40px;
      margin:70px auto 0;
      border: 1px solid #dcdcdc;
      cursor: pointer; 
    }
  }
}

</style>
